import { createContext } from 'react'
import type { Context } from 'react'
import type { LegacyCampaignStateType } from 'storeContext/reducers/campaign/types'
import type { CampaignDispatchType } from 'storeContext/actions/campaign/types'

export type CampaignContextValueType = {
  state: LegacyCampaignStateType
  dispatch: CampaignDispatchType
}

// Keep the original raw-state default and provider identity.
export const createCampaignContext = (initialState: LegacyCampaignStateType) =>
  createContext(initialState) as unknown as Context<CampaignContextValueType>
